import i18n from '@/f1/service/i18n';

import KO from './i18n.ko';
import EN from './i18n.en';

export default i18n({ EN, KO });